'use client'

import { HTMLProps } from 'react'
import clsx from 'classnames'
import { motion } from 'framer-motion'
import { Text } from '@/shared/ui'
import { Member } from '@/shared/ui/member'
import { IBlockPersonsItem } from '@/interfaces/blocks'

import { useAppearance } from '@/shared/utils'
import { variantsHeadline } from '@/shared/constants/variants'
import style from './persons.module.scss'

interface PersonsProps extends HTMLProps<HTMLDivElement> {
  items: IBlockPersonsItem[]
  title: string
  highlight_first?: boolean
}

export const Persons = (props: PersonsProps) => {
  const { className, title, items, highlight_first } = props
  const { ref: innerRef, animate } = useAppearance()

  return (
    <motion.section
      ref={innerRef}
      animate={animate}
      variants={variantsHeadline}
      className={clsx(style.container, className)}
    >
      <Text className={style.title} color="dark" type="h2" tagName="h3">
        {title}
      </Text>

      <ul className={style.list}>
        {items.map(({ ...restProps }, index) => (
          <Member
            className={clsx(style.item, { [style.pinned]: highlight_first && index === 0 })}
            key={index}
            {...restProps}
          />
        ))}
      </ul>
    </motion.section>
  )
}
